import { useQuery } from "react-query";

import { mapBrandingSettings } from "mappers";
import { brandingService } from "services";

const useBrandingSettingsAgentQuery = ({
	agentId,
	companyId,
	setLogoPath,
	isTakeFromAgentOffice,
}: {
	agentId: string;
	companyId: string;
	setLogoPath: Function;
	isTakeFromAgentOffice?: boolean;
}) => {
	const queryResult = useQuery(
		["brandingSettingsAgent", isTakeFromAgentOffice],
		() => {
			return isTakeFromAgentOffice
				? brandingService.getBrandingSettingsAgentOffice({ companyId })
				: brandingService.getBrandingSettingsAgent({ agentId });
		},
		{
			retry: 0,
			cacheTime: 0,
			enabled: !!companyId && isTakeFromAgentOffice !== undefined,
			select: mapBrandingSettings,
			onSuccess(result) {
				setLogoPath(result?.publicLogoUrl);
			},
		},
	);

	return queryResult;
};

export default useBrandingSettingsAgentQuery;
